import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { track } from '../../../helpers';
import TrackingEvents from '../../../common/models/TrackingEvents';

class SizeSelector extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  componentDidUpdate(prevProps, prevState) {
    const { open } = this.state;
    if (open && !prevState.open) {
      document.addEventListener('click', this.onOutsideClick);
    } else if (!open && prevState.open) {
      document.removeEventListener('click', this.onOutsideClick);
    }
  }

  onOutsideClick = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      isOutOfStock,
      selectedLabel,
      selectedSize,
      selectFn,
      selectorOptions,
      selectorTitleText,
      showSelectSizeBadge,
      sizeUnitSystem
    } = this.props;

    const { open } = this.state;

    return (
      <div id="product_sizes">
        <div
          id="size_selector_cnt"
          className={`${isOutOfStock ? 'inactive' : ''} ${open ? 'open' : 'inactive'}`}
          onClick={() => {
            this.setState({ open: !open });
            if (!open) {
              track(TrackingEvents.sizeListViewed(), {
                ui: {
                  size_system: sizeUnitSystem,
                  sizes: selectorOptions.map(el => el.size)
                }
              });
            }
          }}
        >
          <div id="size_selector">
            <span
              id={`${isOutOfStock ? 'out_of_stock_text' : 'size_selector_text'}`}
              data-prefix_text="Selected size:"
              data-cy="span-size-selector-label"
            >
              {selectedSize ? selectedLabel : isOutOfStock ? 'sold out' : selectorTitleText}
            </span>
            {showSelectSizeBadge && (
              <span style={{ marginLeft: '5px' }} className="badge badge-important">
                !
              </span>
            )}
            <i className="icon-angle-down" />
            <i className="icon-angle-up" />
          </div>
          <ul id="sizes_cnt" style={{ zIndex: 1 }}>
            {selectorOptions.map((option, index) => (
              <li
                key={index}
                className={`${option.disabled ? 'unavailable' : ''}`}
                id={`size_system_id_${index}`}
                data-cy="li-size-selector-option"
                onClick={() => {
                  if (!option.disabled) {
                    selectFn(option.label, option.value, option.recapLabel);
                    setTimeout(() => this.setState({ open: false }));
                  }
                }}
              >
                <span className="product_size_size">
                  {`${option.size}${option.disabled ? ' (Not Available)' : ''}`}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

SizeSelector.propTypes = {
  isOutOfStock: PropTypes.bool,
  selectedLabel: PropTypes.string,
  selectedSize: PropTypes.string,
  selectFn: PropTypes.func,
  selectorOptions: PropTypes.array.isRequired,
  selectorTitleText: PropTypes.string.isRequired,
  showSelectSizeBadge: PropTypes.bool,
  sizeUnitSystem: PropTypes.string
};

export default SizeSelector;
